const routes = {
  'home': {
    url: '/'
  },
  'contact': {
    url: '/contacto'
  },
  'legals': {
    url: '/legales'
  },
  'codeOfEthics': {
    url: '/legales/codigo-de-etica'
  },
  'authorizationKeys': {
    url: '/legales/claves-de-autorizacion'
  },
  'noticeOfPrivacy': {
    url: '/legales/aviso-de-privacidad'
  },
  'global': {
    url: '/sanfer-global'
  },
  'aboutUs': {
    url: '/sobre-nosotros'
  },
  'history': {
    url: '/historia'
  },
  'operations': {
    url: '/produccion-y-operaciones'
  },
  'pharmacovigilance': {
    url: '/farmacovigilancia'
  },
  'vademecum': {
    url: '/vademecum'
  },
  'products': {
    url: '/productos'
  },
  'freeSale': {
    url: '/productos/libre-venta'
  },
  'prescription': {
    url: '/productos/prescripcion'
  },
  'animalHealth': {
    url: '/productos/salud-animal'
  },
  'sanferConecta': {
    url: '/sanfer-conecta'
  },
  'healthcareProfessionals': {
    url: '/profesionales-de-la-salud'
  },
  'post': {
    url: '/blog'
  },
  'blog': {
    url: '/post'
  },
  'construction': {
    url: '/en-construccion'
  }
}

export const getURLByRouteName = routeName => {
  let route = routes[routeName]
    , url = route ? route.url : '/'
  return url
}